export default "__VITE_ASSET__o$K4Yesj__"